export const clinicInfo = {
  name: 'Femme Vie',
  tagline: 'Ginecologia Avançada & Saúde Feminina',
  description: 'Clínica boutique de saúde feminina em Fortaleza, dedicada ao cuidado integral da mulher em todas as fases da vida. Aliamos tecnologia de ponta, conhecimento científico e atendimento humanizado para proporcionar uma experiência única em saúde.',
  phone: '(85) 3045-8454',
  whatsapp: '5585984293412',
  email: 'contato@clinicafemmevie.com.br',
  address: {
    street: 'Rua Dr. Gilberto Studart, 55',
    complement: 'Torre Sul, Sala 610 - Duets Office Tower',
    neighborhood: 'Cocó',
    city: 'Fortaleza',
    state: 'CE',
    zip: '60192-095',
  },
  hours: 'Segunda a Sexta, 8h às 18h',
  instagram: 'https://www.instagram.com/clinicafemmevie/',
  googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3035153932466!2d-38.4849!3d-3.7550!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwNDUnMTguMCJTIDM4wrAyOScwNS42Ilc!5e0!3m2!1spt-BR!2sbr!4v1690000000000!5m2!1spt-BR!2sbr',
};

export const specialties = [
  {
    id: 'ginecologia',
    title: 'Ginecologia Avançada',
    description: 'Cuidado integral da saúde feminina com abordagem personalizada, desde a adolescência até a maturidade. Prevenção, diagnóstico e tratamento com tecnologia de ponta.',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20medical%20office%20interior%20with%20soft%20rose%20and%20beige%20tones%2C%20modern%20gynecology%20clinic%20with%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20feminine%20yet%20professional%20atmosphere%2C%20organic%20shapes%2C%20fresh%20flowers%2C%20boutique%20medical%20spa%20feel&width=800&height=600&seq=femme-spec-gyn-01&orientation=landscape',
  },
  {
    id: 'obstetricia',
    title: 'Obstetrícia',
    description: 'Acompanhamento completo da gestação, do pré-natal ao pós-parto, com uma equipe dedicada a tornar esse momento único ainda mais especial e seguro.',
    icon: 'ri-user-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20elegant%20medical%20consultation%20room%20in%20beige%20and%20cream%20tones%2C%20pregnancy%20care%20setting%2C%20gentle%20lighting%2C%20minimalist%20luxury%20interior%2C%20organic%20textures%2C%20warm%20atmosphere%2C%20female%20wellness%20clinic%20aesthetic&width=800&height=600&seq=femme-spec-obst-02&orientation=landscape',
  },
  {
    id: 'pre-natal',
    title: 'Pré-Natal Personalizado',
    description: 'Pré-natal de excelência com acompanhamento individualizado, exames de última geração e suporte emocional durante toda a jornada da gestação.',
    icon: 'ri-calendar-check-line',
    image: 'https://readdy.ai/api/search-image?query=Serene%20pregnancy%20wellness%20space%20with%20soft%20natural%20light%2C%20beige%20and%20cream%20interior%2C%20elegant%20minimalist%20design%2C%20comforting%20atmosphere%2C%20fresh%20eucalyptus%20branches%2C%20boutique%20medical%20setting%2C%20feminine%20aesthetic&width=800&height=600&seq=femme-spec-prenatal-03&orientation=landscape',
  },
  {
    id: 'menopausa',
    title: 'Menopausa & Longevidade',
    description: 'Abordagem moderna e acolhedora para a menopausa, com reposição hormonal personalizada, tratamentos regenerativos e foco na qualidade de vida.',
    icon: 'ri-flower-line',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20minimalist%20wellness%20space%20with%20warm%20beige%20and%20soft%20gold%20accents%2C%20mature%20woman%20wellness%20concept%2C%20elegant%20interior%20with%20dried%20flowers%2C%20soft%20lighting%2C%20premium%20medical%20spa%20aesthetic%2C%20organic%20ceramic%20elements&width=800&height=600&seq=femme-spec-meno-04&orientation=landscape',
  },
  {
    id: 'ultrassonografia',
    title: 'Ultrassonografia',
    description: 'Exames de imagem com equipamentos de alta precisão, incluindo ultrassonografia ginecológica, obstétrica e transvaginal com laudos detalhados.',
    icon: 'ri-scan-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20diagnostic%20room%20with%20soft%20ambient%20lighting%2C%20elegant%20beige%20and%20cream%20interior%2C%20ultrasound%20equipment%20in%20luxury%20setting%2C%20minimalist%20design%2C%20warm%20atmosphere%2C%20premium%20healthcare%20environment&width=800&height=600&seq=femme-spec-ultra-05&orientation=landscape',
  },
  {
    id: 'estetica-intima',
    title: 'Estética Íntima',
    description: 'Procedimentos estéticos íntimos com tecnologia a laser e radiofrequência, realizados com total discrição, segurança e resultados naturais.',
    icon: 'ri-sparkling-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20spa%20treatment%20room%20in%20soft%20rose%20and%20beige%20tones%2C%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20premium%20aesthetic%20clinic%20interior%2C%20organic%20shapes%2C%20fresh%20flowers%2C%20feminine%20wellness%20atmosphere&width=800&height=600&seq=femme-spec-estet-06&orientation=landscape',
  },
];

export const differentials = [
  {
    id: 'humanizado',
    title: 'Atendimento Humanizado',
    description: 'Cada paciente é única. Dedicamos tempo para ouvir, compreender e criar um plano de cuidado verdadeiramente personalizado.',
    icon: 'ri-heart-3-line',
  },
  {
    id: 'equipe',
    title: 'Equipe Especializada',
    description: 'Médicas com formação em instituições de excelência, mestrado e especializações nas mais avançadas técnicas em saúde feminina.',
    icon: 'ri-team-line',
  },
  {
    id: 'tecnologia',
    title: 'Tecnologia de Ponta',
    description: 'Equipamentos modernos para diagnósticos precisos e tratamentos minimamente invasivos com resultados superiores.',
    icon: 'ri-cpu-line',
  },
  {
    id: 'estrutura',
    title: 'Consultório Premium',
    description: 'Ambiente cuidadosamente projetado para proporcionar conforto, privacidade e bem-estar em cada visita.',
    icon: 'ri-building-2-line',
  },
  {
    id: 'localizacao',
    title: 'Localização Privilegiada',
    description: 'No coração do Cocó, em uma das regiões mais nobres de Fortaleza, com fácil acesso e estacionamento.',
    icon: 'ri-map-pin-line',
  },
  {
    id: 'exclusivo',
    title: 'Atendimento Exclusivo',
    description: 'Agenda limitada para garantir o tempo necessário a cada paciente, sem pressa, com total atenção.',
    icon: 'ri-star-line',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Maria Eduarda S.',
    rating: 5,
    text: 'Atendimento impecável! A Dra. Nathália é extremamente atenciosa, tirou todas as minhas dúvidas e me fez sentir muito segura. O consultório é lindo e super confortável. Recomendo demais!',
    date: '2026',
  },
  {
    id: 2,
    name: 'Camila R.',
    rating: 5,
    text: 'Melhor experiência ginecológica que já tive. A clínica é um verdadeiro spa da saúde feminina. A Dra. Mayna é incrível, super atualizada e com um cuidado que nunca encontrei em outro lugar.',
    date: '2026',
  },
  {
    id: 3,
    name: 'Beatriz L.',
    rating: 5,
    text: 'Fiz meu pré-natal todo na Femme Vie e foi a melhor decisão. Me senti acolhida em cada consulta, cada ultrassom era um momento especial. Elas realmente se importam com a paciente.',
    date: '2026',
  },
  {
    id: 4,
    name: 'Ana Carolina M.',
    rating: 5,
    text: 'Busquei a clínica para tratamento de menopausa e encontrei muito mais que isso. Encontrei um espaço que entende a mulher de verdade. A abordagem com reposição hormonal mudou minha qualidade de vida.',
    date: '2026',
  },
  {
    id: 5,
    name: 'Juliana F.',
    rating: 5,
    text: 'Ambiente sofisticado, equipe educadíssima e médicas excepcionais. A Femme Vie ressignificou minha relação com os cuidados ginecológicos. Não troco por nada!',
    date: '2026',
  },
  {
    id: 6,
    name: 'Patrícia A.',
    rating: 5,
    text: 'Sou paciente da Dra. Mayna há mais de um ano e só tenho elogios. Ela é extremamente competente e humana. A clínica é impecável, desde a recepção até o consultório. Vale cada minuto.',
    date: '2026',
  },
  {
    id: 7,
    name: 'Larissa D.',
    rating: 5,
    text: 'Fiz procedimento de estética íntima e fiquei encantada com o profissionalismo. Tudo explicado nos mínimos detalhes, resultado maravilhoso e acompanhamento pós muito cuidadoso.',
    date: '2026',
  },
  {
    id: 8,
    name: 'Fernanda T.',
    rating: 5,
    text: 'Dra. Nathália foi minha médica durante toda a gestação e parto. Não tenho palavras para descrever o quanto ela foi importante nesse processo. Uma médica que realmente ama o que faz.',
    date: '2026',
  },
];

export const faqItems = [
  {
    id: 1,
    question: 'Quais convênios a Femme Vie atende?',
    answer: 'A Femme Vie atende exclusivamente pacientes particulares. Essa escolha nos permite dedicar o tempo necessário a cada consulta, garantindo um atendimento verdadeiramente personalizado e sem as limitações impostas pelos planos de saúde. Emitimos nota fiscal para reembolso junto ao seu convênio.',
  },
  {
    id: 2,
    question: 'Como agendar uma consulta?',
    answer: 'O agendamento pode ser feito pelo WhatsApp (85) 9 8429-3412, pelo telefone (85) 3045-8454 ou presencialmente em nossa clínica. Nossa equipe de recepção está disponível de segunda a sexta, das 8h às 18h, para encontrar o melhor horário para você.',
  },
  {
    id: 3,
    question: 'Quanto tempo dura uma consulta?',
    answer: 'Nossas consultas são agendadas com tempo generoso. Uma primeira consulta dura em média 50 minutos, permitindo uma anamnese completa e espaço para todas as suas dúvidas. Consultas de retorno têm duração média de 30 minutos.',
  },
  {
    id: 4,
    question: 'A clínica realiza exames no local?',
    answer: 'Sim. Dispomos de equipamentos modernos para ultrassonografia ginecológica e obstétrica, colposcopia, histeroscopia e coleta de exames preventivos. Os exames são realizados no mesmo ambiente, proporcionando conforto e praticidade.',
  },
  {
    id: 5,
    question: 'Quais tratamentos de estética íntima são oferecidos?',
    answer: 'Trabalhamos com tecnologia a laser e radiofrequência para procedimentos estéticos íntimos, incluindo tratamento de flacidez vaginal, ressecamento, rejuvenescimento íntimo e clareamento. Cada caso é avaliado individualmente em consulta.',
  },
  {
    id: 6,
    question: 'A clínica oferece acompanhamento de pré-natal?',
    answer: 'Sim, o pré-natal é uma das nossas especialidades. Oferecemos acompanhamento completo da gestação, com consultas regulares, exames de ultrassom no consultório, suporte nutricional e emocional durante todo o período gestacional e pós-parto.',
  },
  {
    id: 7,
    question: 'Como funciona o tratamento para menopausa?',
    answer: 'Nossa abordagem para a menopausa é moderna e integral. Após avaliação clínica e hormonal detalhada, elaboramos um plano personalizado que pode incluir reposição hormonal bioidêntica, suplementação, orientação nutricional e tratamentos estéticos, visando qualidade de vida e longevidade saudável.',
  },
];

export const doctors = [
  {
    id: 'dra-nathalia',
    name: 'Dra. Nathália Posso Lima',
    slug: 'dra-nathalia',
    role: 'Ginecologista & Obstetra',
    crm: 'CRM-CE 14200 / RQE 8571',
    shortBio: 'Mestre em Ensino na Saúde, especialista em Ginecologia e Obstetrícia com foco em cirurgia minimamente invasiva e ultrassonografia. Uma abordagem que une excelência técnica e acolhimento genuíno.',
    specialties: ['Ginecologia Geral', 'Obstetrícia', 'Ultrassonografia', 'Cirurgia Ginecológica Minimamente Invasiva'],
    image: 'https://storage.readdy-site.link/project_files/ed85e06b-2b23-49e7-a477-ed0f88fc71a8/553e3dd5-ff0e-4818-bd38-28d0ef016405_compressed_Captura-de-tela-2026-07-22-152724.webp',
    instagram: 'https://www.instagram.com/dranathaliaposso/',
  },
  {
    id: 'dra-mayna',
    name: 'Dra. Mayna Moura',
    slug: 'dra-mayna-moura',
    role: 'Ginecologista & Obstetra',
    crm: 'CRM-CE 14202',
    shortBio: 'Especialista em Ginecologia Regenerativa e Funcional, com foco em estética íntima, menopausa e longevidade feminina. Apaixonada por devolver autoestima e qualidade de vida às mulheres.',
    specialties: ['Ginecologia Regenerativa', 'Estética Íntima', 'Menopausa & Longevidade', 'Histeroscopia Cirúrgica'],
    image: 'https://storage.readdy-site.link/project_files/ed85e06b-2b23-49e7-a477-ed0f88fc71a8/ca03a2b0-c413-4162-9464-1f5840146eb4_compressed_Captura-de-tela-2026-07-22-152840.webp',
    instagram: 'https://www.instagram.com/dramaynamoura/',
  },
];

export const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Sobre', href: '/sobre' },
  { label: 'Especialidades', href: '/especialidades' },
  { label: 'Estrutura', href: '/estrutura' },
  { label: 'Blog', href: '/blog' },
  { label: 'Contato', href: '/contato' },
];

export const clinicPhotos = [
  {
    src: 'https://storage.readdy-site.link/project_files/ed85e06b-2b23-49e7-a477-ed0f88fc71a8/3bf23a0e-2365-45ae-8fb4-2a8da012fe18_compressed_Captura-de-tela-2026-07-22-152648.webp',
    alt: 'Recepção da Clínica Femme Vie',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/ed85e06b-2b23-49e7-a477-ed0f88fc71a8/b176f958-bca0-41a4-8224-9bcde8e72d75_compressed_Captura-de-tela-2026-07-22-162315.webp',
    alt: 'Consultório da Femme Vie',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Modern%20ultrasound%20examination%20room%20in%20luxury%20medical%20clinic%2C%20beige%20and%20warm%20tones%2C%20state%20of%20art%20equipment%2C%20soft%20lighting%2C%20elegant%20minimalist%20design%2C%20comfortable%20patient%20area%2C%20premium%20healthcare%20setting&width=1200&height=800&seq=femme-clinic-03&orientation=landscape',
    alt: 'Sala de Ultrassonografia',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Luxurious%20medical%20spa%20treatment%20room%20with%20warm%20beige%20walls%2C%20soft%20rose%20accents%2C%20ambient%20lighting%2C%20elegant%20minimal%20design%2C%20fresh%20orchids%2C%20premium%20aesthetic%20clinic%20interior%2C%20feminine%20sophisticated%20atmosphere&width=1200&height=800&seq=femme-clinic-04&orientation=landscape',
    alt: 'Sala de Procedimentos Estéticos',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Comfortable%20waiting%20lounge%20in%20premium%20medical%20clinic%2C%20cream%20and%20beige%20decor%2C%20large%20windows%20with%20natural%20light%2C%20elegant%20furniture%2C%20fresh%20flowers%2C%20magazines%2C%20minimalist%20luxury%20design%2C%20warm%20welcoming%20atmosphere&width=1200&height=800&seq=femme-clinic-05&orientation=landscape',
    alt: 'Sala de Espera',
  },
];